import {ValueObject} from '@s-ui/domain'

export class GetRecommendedPriceSellerRequest extends ValueObject {
  /**
   * @param {String} queryParams
   */

  getQueryParams() {
    return this._queryParams
  }
}
